import {enumType} from 'common/enumType';

export type DiplomatObjectTypeUnion = keyof typeof DiplomatObjectType.enum;

export const DiplomatObjectType = enumType({
   ARCHIVE_SETTINGS: 'Primary Archive Settings',
   AUDIT_TRAIL_SETTINGS: 'Audit Trail Settings',
   AUTH_POLICIES: 'Authentication Policies',
   BACKUP_SETTINGS: 'Backup Settings',
   CONFIG_SETTINGS: 'Config Settings',
   EMAIL_SERVER_SETTINGS: 'Email Server Settings',
   ENCRYPTION_PRODUCT_SETTINGS: 'OpenPGP Server Settings',
   EXTERNAL_PARTNER: 'Public Partner',
   FOLDER: 'Folder',
   FTP_ADMIN_SETTINGS: 'FTP Server Settings',
   FTP_SETTINGS: 'FTP Settings',
   HOLIDAY_CALENDAR: 'Holiday Calendar',
   INBOUND_TRANSACTION: 'Inbound Transaction',
   INTERNAL_PARTNER: 'Trusted Partner',
   IT_SUPPORT_EMAIL_SETTINGS: 'IT Support Email Settings',
   JOB_HISTORY_SETTINGS: 'Job History Settings',
   JOB_SETTINGS: 'Job Settings',
   JOB_SUSPENSION: 'Job Suspension',
   KEY_PAIR: 'OpenPGP Key Pair',
   KEY_SETTINGS: 'OpenPGP Key Settings',
   LOG_FILE_SETTINGS: 'Log File Settings',
   OUTBOUND_TRANSACTION: 'Outbound Transaction',
   PAGING_SETTINGS: 'Paging Settings',
   PASSWORD_DATA: 'Password Data',
   PROXY_SERVER: 'Proxy Server',
   PUBLIC_KEY: 'OpenPGP Public Key',
   SCHEDULED_REPORT: 'Scheduled Report',
   SESSION_DATA: 'Session Data',
   SSH_KEY: 'SSH Key',
   SSH_HOST_KEY: 'SSH Host Key',
   SSL_CERTIFICATE: 'SSL Certificate',
   SSL_CLIENT_CERTIFICATE: 'SSL Client Certificate',
   TIMEOUT_RETRY_SETTINGS: 'Timeout/Retry Settings',
   USER: 'User',
   AS2_SETTINGS: 'AS2',
   BISCOM_SETTINGS: 'Biscom Server Settings',
   SFTP_SERVER_SETTINGS: 'File Transfer Server Settings',
   SSH_PUBLIC_KEY: 'SSH Public Key',
   SFTP_USER: 'User',
   SFTP_SERVER: 'File Transfer Server',
   VFS_GROUP: 'Group',
   VFS: 'Filesystem',
   VFS_PERMISSION: 'VFS_PERMISSION',
   SFTP_USER_STATUS: 'User Status',
   SYNCHRONIZATION: 'Synchronization',
   LDAP_SETTINGS: 'LDAP Settings',
   ADMIN_ROLE: 'Admin Role',
   SAML_SETTINGS: 'SAML Settings',

   LOADER: 'LOADER',
});
